import { makeObservable, observable, flow, action } from "mobx";
import { toast } from "sonner";

import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

export default class RequirementHistoryStore {
  visible = false;
  loading = false;
  requirementId = null;
  requirement = null;
  kind = null;
  recent = [];
  upcoming = [];
  error = null;

  constructor(parentStore) {
    makeObservable(this, {
      visible: observable,
      loading: observable,
      requirementId: observable,
      requirement: observable,
      kind: observable,
      recent: observable,
      upcoming: observable,
      error: observable,
      show: action,
      toggle: action,
      load: flow,
    });

    this.parentStore = parentStore;
  }

  show(requirement) {
    this.requirementId = requirement?.id ?? null;
    this.requirement = requirement ?? null;
    this.kind = null;
    this.recent = [];
    this.upcoming = [];
    this.error = null;
    this.visible = true;
    this.load();
  }

  toggle(open) {
    this.visible = open;
    if (!open) {
      this.requirementId = null;
      this.requirement = null;
      this.kind = null;
      this.recent = [];
      this.upcoming = [];
      this.error = null;
    }
  }

  *load() {
    if (!this.requirementId) return { success: false };
    try {
      this.loading = true;
      this.error = null;
      const response = yield api.get(ApiRoutes.forRequirementHistory(this.requirementId), { params: { count: 5 } });
      if (response.status === 200) {
        this.kind = response.data.kind;
        this.recent = response.data.recent ?? [];
        this.upcoming = response.data.upcoming ?? [];
        return { success: true, data: response.data };
      }
      throw new Error("Unexpected status code");
    } catch (e) {
      this.error = e;
      toast.error("Error loading requirement history", {
        description: e?.response?.data?.message || "Unexpected error, please try again later.",
      });
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
